type TThrottled = {
  run: () => void;
  cancel: () => void;
};

const createThrottle = (action: () => void, waitMs: number): TThrottled => {
  let timer: ReturnType<typeof setTimeout> | null = null;

  const clear = () => {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  };

  const run = () => {
    if (timer) {
      return;
    }

    timer = setTimeout(() => {
      timer = null;
      action();
    }, waitMs);
  };

  return { run, cancel: clear };
};

export type {
  TThrottled,
};
export {
  createThrottle,
};
